module.exports = __webpack_public_path__ + "media/hero.e511acab.jpg";